/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Open_End_LogInputs */

const en_us2_workout_quick_open_end_log = /** @type {(inputs: Workout_Quick_Open_End_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close that one and log`)
};

const pt_br2_workout_quick_open_end_log = /** @type {(inputs: Workout_Quick_Open_End_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerrar aquele e registrar`)
};

const es_419_workout_quick_open_end_log = /** @type {(inputs: Workout_Quick_Open_End_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar aquel y registrar`)
};

const pt_pt2_workout_quick_open_end_log = /** @type {(inputs: Workout_Quick_Open_End_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar aquele e registar`)
};

const fr_fr2_workout_quick_open_end_log = /** @type {(inputs: Workout_Quick_Open_End_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer l'autre et noter`)
};

const de_de2_workout_quick_open_end_log = /** @type {(inputs: Workout_Quick_Open_End_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anderes beenden und eintragen`)
};

const it_it2_workout_quick_open_end_log = /** @type {(inputs: Workout_Quick_Open_End_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi quello e registra`)
};

/**
* | output |
* | --- |
* | "Close that one and log" |
*
* @param {Workout_Quick_Open_End_LogInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_open_end_log = /** @type {((inputs?: Workout_Quick_Open_End_LogInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Open_End_LogInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_open_end_log(inputs)
	if (locale === "es-419") return es_419_workout_quick_open_end_log(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_open_end_log(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_open_end_log(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_open_end_log(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_open_end_log(inputs)
	return en_us2_workout_quick_open_end_log(inputs)
});
export { workout_quick_open_end_log as "workout-quick.open_end_log" }